import { render, staticRenderFns } from "./CategoryOrderModal.vue?vue&type=template&id=a0ae80b0&scoped=true"
import script from "./CategoryOrderModal.vue?vue&type=script&lang=js"
export * from "./CategoryOrderModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryOrderModal.vue?vue&type=style&index=0&id=a0ae80b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ae80b0",
  null
  
)

export default component.exports